import { Component, Input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-email-input',
    templateUrl: './email-input.component.html',
    styleUrls: ['./email-input.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, FormFieldLabelComponent],
})
export class EmailInputComponent {
    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}
}
